import DNATraits from "./DNATraits";
export default DNATraits;
